import { location } from '@/infrastructure/Configuration'

export default class ExperienceAccumulatedPrice {
  constructor({ trackingId, experienceIds, qubitService }) {
    this.trackingId = trackingId
    this.experienceIds = experienceIds
    this.qubitService = qubitService
  }

  async accordingExperienceWhenConfigDynamic() {
    let experience = null
    try {
      experience = await this.qubitService.newExperience({
        trackingId: this.trackingId,
        experienceIds: this.experienceIds
      })
      const [{ callback, payload }] = experience.experiencePayloads
      this.qubitService.checkExperience({ checkCallback: callback })
      if (Object.keys(payload).length === 0) {
        return undefined
      } else {
        const { datasetLabels, datasetParticipatingHotels } = payload
        const datasets = [datasetLabels, datasetParticipatingHotels]

        return {
          trackingId: this.trackingId,
          callback,
          datasets
        }
      }
    } catch (e) {
      return undefined
    }
  }

  async getLabelsQubit({ hotelCode }) {
    const experiencePayload = await this.accordingExperienceWhenConfigDynamic()
    if (experiencePayload === undefined) return {}
    const { trackingId, datasets: [datasetlabels, datasetParticipatingHotels] } = experiencePayload
    let dataQubit = null
    const datasetLabels = await this.qubitService.dataSetExperience({
      trackingId,
      dataset: datasetlabels,
      key: location.slice(0, 2)
    })

    const datasetHotels = await this.qubitService.dataSetExperience({
      trackingId,
      dataset: datasetParticipatingHotels,
      key: hotelCode
    })

    dataQubit = await this.getDataQubit({
      datasetLabels,
      datasetHotels,
      hotelCode

    })
    return dataQubit
  }

  async getDataQubit({ datasetLabels, datasetHotels, hotelCode }) {
    const hotels = await datasetHotels[0]
    const labels = await datasetLabels[0]

    let props = {
      hotel: false,
      hotelCode
    }

    if (!labels && hotels?.hotel_code) {
      props = {
        hotel: true,
        hotelCode,
        labels: {
          for: 'for',
          nights: 'nights',
          language: 'en'
        }
      }
    } else if (hotels?.hotel_code && labels?.language) {
      const { for: label1, language, nights } = labels
      props = {
        hotel: true,
        hotelCode,
        labels: {
          for: label1,
          nights,
          language
        }
      }
    }
    return props
  }
}
